/**
 * Page-load event loop and error event helpers.
 *
 * Moved from templates/components/scripts/event-loop.html (Phase 3 refactor).
 * Handlebars dependencies (client IP address, page type) are read at call-time
 * from window.BC_CONTEXT which is populated by init-globals.html before the bundle loads.
 *
 * window.initialPageViewSent is set here and read by analytics-sender.js to prevent
 * duplicate "search results" events from SearchSpring's own replaceState calls.
 */

// De-Tealium: the initial page_view fires after a short delay (was gated on utag
// detection) to give SearchSpring time to populate the search-results count.
const PAGE_VIEW_FIRE_RETRIES = 1;
const PAGE_VIEW_FIRE_INTERVAL_MS = 50;

// Set to true once the initial page-view event is dispatched.
// Prevents onUrlChange from firing onSearchPageContentsChange for SS's
// own replaceState calls that happen during initialization.
window.initialPageViewSent = false;

export function pageLoadErrorEvents() {
    const pageType = window.getPageType?.() || window.BC_CONTEXT?.pageType || '';
    let newEvent = {
        loadNumber: 0,
        scriptLoaded: false,
        interactionsCompleted: false,
        errorMessage: {
            eventName: "page_view",
            eventMessage: "",
            pageType,
            timeStamp: new Date().toISOString()
        }
    };
    let sentCount = 0;
    const pageViewIntervalId = setInterval(() => {
        if (sentCount >= PAGE_VIEW_FIRE_RETRIES) {
            clearInterval(pageViewIntervalId);
            // Re-read SS cache now — by the time this fires, SearchSpring has had
            // time to initialize and populate ss-networkcache.
            const latestTotal = typeof window.GetSearchResults === 'function' ? window.GetSearchResults() : 0;
            if (latestTotal > 0) {
                window.basePageViewEvent.search_results = String(latestTotal);
            }
            const topCat = typeof window.getMostRepresentedCategory === 'function' ? window.getMostRepresentedCategory() : '';
            if (topCat && window.basePageViewEvent) {
                window.basePageViewEvent.most_represented_category = topCat;
            }
            window.queueEventFile?.(newEvent, window.basePageViewEvent);
            window.initialPageViewSent = true;
        }
        sentCount++;
    }, PAGE_VIEW_FIRE_INTERVAL_MS);
}

export function getDefaultData() {
    return {
        siteErrors: {
            tealiumFailures: {
                userAgent: [navigator.userAgent],
                ip_address: [window.BC_CONTEXT?.client_ip_address || ''],
                cartId: []
            }
        }
    };
}
